<template>
    <VFlex flex-direction="column">
        <ImageHeader>
            <template #image>
                <img :src="LegalNoticeHeader" alt="Administration" />
            </template>

            <template #title>
                <div><Translate path=".title"></Translate></div>
                <div class="has-text-primary">
                    <Translate path=".subTitle"></Translate>
                </div>
            </template>
        </ImageHeader>
        <VFlex flex-direction="row" column-gap="40px" class="m-6">
            <VFlex flex-direction="column">
                <h3 class="is-size-4 is-weight-700 has-text-dark is-uppercase my-5">
                    <Translate>.title1</Translate>
                </h3>
                <p class="has-text-dark">
                    <Translate>.content1</Translate>
                </p>
                <h3 class="is-size-4 is-weight-700 has-text-dark is-uppercase my-5">
                    <Translate>.title2</Translate>
                </h3>
                <p class="has-text-dark">
                    <Translate>.content2</Translate>
                </p>
                <h3 class="is-size-4 is-weight-700 has-text-dark is-uppercase my-5">
                    <Translate>.title3</Translate>
                </h3>
                <p class="has-text-dark">
                    <Translate>.content3</Translate>
                </p>
                <h3 class="is-size-4 is-weight-700 has-text-dark is-uppercase my-5">
                    <Translate>.title4</Translate>
                </h3>
                <p class="has-text-dark">
                    <Translate>.content4</Translate>
                </p>
            </VFlex>
            <VFlex flex-direction="column">
                <h3 class="is-size-4 is-weight-700 has-text-dark is-uppercase my-5">
                    <Translate>.title5</Translate>
                </h3>
                <p class="has-text-dark">
                    <Translate>.content5</Translate>
                </p>
                <h3 class="is-size-4 is-weight-700 has-text-dark is-uppercase my-5">
                    <Translate>.title6</Translate>
                </h3>
                <p class="has-text-dark">
                    <Translate>.content6</Translate>
                </p>
                <h3 class="is-size-4 is-weight-700 has-text-dark is-uppercase my-5">
                    <Translate>.title7</Translate>
                </h3>
                <p class="has-text-dark">
                    <Translate>.content7</Translate>
                </p>
                <h3 class="is-size-4 is-weight-700 has-text-dark is-uppercase my-5">
                    <Translate>.title8</Translate>
                </h3>
                <p class="has-text-dark">
                    <Translate>.content8</Translate>
                </p>
            </VFlex>
        </VFlex>
        <Footer></Footer>
    </VFlex>
</template>

<script setup lang="ts">
import LegalNoticeHeader from "../../assets/image/legalNotice/header.jpg";
import Footer from "../../components/website/Footer.vue";
import { setTranslateNamespace } from "addeus-common-library/stores/translate";
import { useSeoMeta } from "../../composables/useSeoMeta";

setTranslateNamespace("speed2max.legalNotice");

useSeoMeta({
    title: "Mentions légales",
    description:
        "Mentions légales du site Speed2Max. Informations sur l'éditeur, les données personnelles et les conditions d'utilisation.",
    path: "/legal-notice",
    robots: "noindex, follow",
});
</script>

<style scoped>
h3 {
    font-family: "Bebas Neue";
}
</style>
